<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { LinkTextPrimary } from '@shared/ui/links'

import { useTaskCommon } from '../../model/task-common.hook'
import TaskInfoList from './TaskInfoList.vue'
import TaskInfoItem from './TaskInfoItem.vue'

defineOptions({
  name: 'TaskCommon',
})

const {
  refCreatedAt,
  refUpdatedAt,
  refHasCreator,
  refCreatorName,
  refCreatorHref,
} = useTaskCommon()
</script>

<template>
  <TaskInfoList>
    <TaskInfoItem title="Created at">
      <AppText
        name="body1"
        color="slate-900"
      >
        {{ refCreatedAt || '-' }}
      </AppText>
      <template v-if="refHasCreator">
        <AppText
          name="body1"
          color="slate-500"
        >
          by
        </AppText>
        <LinkTextPrimary
          :href="refCreatorHref"
          target="_blank"
        >
          {{ refCreatorName }}
        </LinkTextPrimary>
      </template>
    </TaskInfoItem>
    <TaskInfoItem title="Updated at">
      <AppText
        name="body1"
        color="slate-900"
      >
        {{ refUpdatedAt || '-' }}
      </AppText>
    </TaskInfoItem>
  </TaskInfoList>
</template>
